import React, { useContext, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  FormControl,
  Button,
  Modal,
  Typography,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  Tooltip,
} from "@mui/material";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import ApiEndpoints from "../../network/ApiEndPoints";
import { CustomStyles } from "../../component/CustomStyle";
import CachedIcon from "@mui/icons-material/Cached";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from "xlsx";
import ApporveReject from "./ApporveReject";
import AddLeave from "./AddDeveloperLeave";
import AddDeveloperLeave from "./AddDeveloperLeave";
import AuthContext from "../../store/AuthContext";
import EditIcon from "@mui/icons-material/Edit";
import { Update } from "@mui/icons-material";
import UpdateLeaveModal from "../../modals/UpdateLeaveModal";
import { get } from "../../network/ApiController";
import { apiErrorToast } from "../../utils/ToastUtil";
import UpdateSingleLeaveModal from "../../modals/UpdateSingleLeaveModal";
import DataFilter from "./Common/DataFilter";
import DescriptionIcon from "@mui/icons-material/Description";
import AddCompensatoryLeave from "./AddCompensatoryLeave";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
};

const TotalLeave = () => {
  const [openModal, setOpenModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [openCompensatoryModal, setOpenCompensatoryModal] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [request, setRequest] = useState(false);
  const [query, setQuery] = useState("");
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  let refresh;

  const refreshFunc = () => {
    setQuery("");
    if (refresh) refresh();
  };

  const getLeave = () => {
    const queryParams = "?page=1&paginate=10";

    get(
      `${ApiEndpoints.TOTAL_LEAVE}${queryParams}`,
      "",
      setRequest,
      (res) => {
        const data = res?.data?.data;
      },
      (error) => {
        apiErrorToast(error);
      }
    );
  };
  const exportToExcel = async () => {
    try {
      const queryParams = "?page=1&paginate=1000";

      get(`${ApiEndpoints.TOTAL_LEAVE}`, query, setRequest, (res) => {
        const employees = res?.data?.data;
        if (!employees || employees.length === 0) {
          alert("No data to export");
          return;
        }

        // 🔹 Prepare Header Row
        const header = [
          "Employee Name",
          "Employee ID",
          "Total CL",
          "Taken CL",
          "Total SL",
          "Taken SL",
          "Total EL",
          "Taken EL",
          "Total ML",
          "Taken ML",
          "Total PL",
          "Taken PL",
          "Total BL",
          "Taken BL",
          "Total Compensatory",
          "Taken Compensatory",
          "Unpaid",
        ];

        // 🔹 Prepare Data Rows (One Row = One Employee Summary)
        const summaryRows = employees.map((emp) => ({
          "Employee Name": emp.emp_name,
          "Employee ID": emp.user_id,
          "Total CL": emp.total_cl,
          "Taken CL": emp.cl,
          "Total SL": emp.total_sl,
          "Taken SL": emp.sl,
          "Total EL": emp.total_el,
          "Taken EL": emp.el,
          "Total ML": emp.total_ml,
          "Taken ML": emp.ml,
          "Total PL": emp.total_pl,
          "Taken PL": emp.pl,
          "Total BL": emp.total_bl,
          "Taken BL": emp.bl,
          "Total Compensatory": emp.total_compensatory,
          "Taken Compensatory": emp.compensatory,
          Unpaid: emp.unpaid,
        }));

        // 🔹 Convert into Worksheet
        const worksheet = XLSX.utils.json_to_sheet(summaryRows, { header });

        // 🔹 Add Headers on Top
        XLSX.utils.sheet_add_aoa(worksheet, [header], { origin: "A1" });

        // 🔹 Create Workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Summary");

        // 🔹 Export File
        const fileName = `Leave_Summary_${
          new Date().toISOString().split("T")[0]
        }.xlsx`;
        XLSX.writeFile(workbook, fileName);
      });
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("Failed to export data. Please try again.");
    }
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setConfirmationModal(false);
  };
 const calculateRowTotals = (row) => {
    const leaveTypes = [
      { total: parseFloat(row.total_cl || 0), left: parseFloat(row.cl || 0) },
      { total: parseFloat(row.total_sl || 0), left: parseFloat(row.sl || 0) },
      { total: parseFloat(row.total_el || 0), left: parseFloat(row.el || 0) },
      { total: parseFloat(row.total_ml || 0), left: parseFloat(row.ml || 0) },
      { total: parseFloat(row.total_pl || 0), left: parseFloat(row.pl || 0) },
      { total: parseFloat(row.total_bl || 0), left: parseFloat(row.bl || 0) },
      { total: parseFloat(row.total_compensatory || 0), left: parseFloat(row.compensatory || 0) },
    ];

    const totalSum = leaveTypes.reduce((sum, item) => sum + item.total, 0);
    const leftSum = leaveTypes.reduce((sum, item) => sum + item.left, 0);
    const takenSum = totalSum - leftSum;

    return { total: totalSum, left: leftSum, taken: takenSum };
  };
  const columns = [
    { name: "Employee ID", selector: (row) => row.user_id },
    { name: "Employee Name", selector: (row) => row.emp_name },
    {
      name: "Total Leave Summary",
      selector: (row) => {
        const { total, left, taken } = calculateRowTotals(row);
        
        return (
          <Box sx={{ 
            display: "flex", 
            flexDirection: "column",
            minWidth: "120px",
            p: 0.5,
            backgroundColor: '#f5f5f5',
            borderRadius: 1
          }}>
            <Typography variant="caption" sx={{ fontSize: '0.75rem', display: 'flex', justifyContent: 'space-between' }}>
              <span>Total:</span>
              <span style={{ fontWeight: 'bold', color: '#1976d2' }}>{total.toFixed(2)}</span>
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '0.75rem', display: 'flex', justifyContent: 'space-between' }}>
              <span>Left:</span>
              <span style={{ fontWeight: 'bold', color: '#2e7d32' }}>{left.toFixed(2)}</span>
            </Typography>
            <Typography variant="caption" sx={{ fontSize: '0.75rem', display: 'flex', justifyContent: 'space-between' }}>
              <span>Taken:</span>
              <span style={{ fontWeight: 'bold', color: '#d32f2f' }}>{taken.toFixed(2)}</span>
            </Typography>
          </Box>
        );
      },
      width: "140px",
      center: true
    },   
    {
      name: "Casual Leave",
      selector: (row) => {
        const total = row.total_cl || 0;
        const left = row.cl ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="cl"
                leaveName="Casual Leave"
              />
            )}
          </div>
        );
      },
    },
    // Repeat this pattern for other leave types...
    {
      name: "Sick Leave",
      selector: (row) => {
        const total = row.total_sl || 0;
        const left = row.sl ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="sl"
                leaveName="Sick Leave"
              />
            )}
          </div>
        );
      },
    },
    {
      name: "Earn Leave",
      selector: (row) => {
        const total = row.total_el || 0;
        const left = row.el ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="el"
                leaveName="Earn Leave"
              />
            )}
          </div>
        );
      },
    },
    {
      name: "Maternity Leave",
      selector: (row) => {
        const total = row.total_ml || 0;
        const left = row.ml ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="ml"
                leaveName="Maternity Leave"
              />
            )}
          </div>
        );
      },
    },
    {
      name: "Paternity Leave",
      selector: (row) => {
        const total = row.total_pl || 0;
        const left = row.pl ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="pl"
                leaveName="Paternity Leave"
              />
            )}
          </div>
        );
      },
    },
    {
      name: "Bereavement Leave",
      selector: (row) => {
        const total = row.total_bl || 0;
        const left = row.bl ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="bl"
                leaveName="Bereavement Leave"
              />
            )}
          </div>
        );
      },
    },
    {
      name: "Compensatory Leave",
      selector: (row) => {
        const total = row.total_compensatory || 0;
        const left = row.compensatory ?? total;
        const taken = left === 0 ? 0 : total - left;
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div>
              <div style={{ color: "black" }}>Total: {total}</div>
              <div style={{ color: "green" }}>Left: {left}</div>
              <div style={{ color: "red" }}>Taken: {taken}</div>
            </div>
            {user.role === "Admin" && (
              <UpdateSingleLeaveModal
                leave={row}
                refresh={refreshFunc}
                leaveType="compensatory"
                leaveName="Compensatory Leave"
              />
            )}
          </div>
        );
      },
    },
    // {
    //   name: "Action",
    //   selector: (row) => (
    //     <div>
    //       {user.role === "Admin" && (
    //         <UpdateLeaveModal leave={row} refresh={refreshFunc} />
    //       )}
    //     </div>
    //   ),
    // },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <DataFilter
          ifemployeeFilter={user.role === "Admin"}
          ifDateRangeFilter={user.role === "Admin"}
          setQuary={setQuery}
          setQuery={setQuery}
        />
        {user.role !== "Admin" && (
          <Button
            variant="contained"
            onClick={() => setOpenCompensatoryModal(true)}
            sx={{mr:3}}
          >
            Request Compensatory
          </Button>
        )}
        {user.role === "Admin" && <AddDeveloperLeave refresh={refreshFunc} />}

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {user.role !== "Admin" && (
            <Tooltip title="Export to Excel">
              <IconButton
                aria-label="export-excel"
                sx={{ color: "#0F52BA" }}
                onClick={exportToExcel}
              >
                <DescriptionIcon />
              </IconButton>
            </Tooltip>
          )}
          <Tooltip title="Refresh">
            <IconButton
              aria-label="refresh"
              sx={{ color: "#0F52BA" }}
              onClick={() => refreshFunc(setQuery)}
            >
              <CachedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      <ApiPaginateSearch
        apiEnd={ApiEndpoints.TOTAL_LEAVE}
        columns={columns}
        apiData={apiData}
        setApiData={setApiData}
        tableStyle={CustomStyles}
        queryParam={query}
        returnRefetch={(ref) => {
          refresh = ref;
        }}
      />

      <AddCompensatoryLeave
        openModal={openCompensatoryModal}
        setOpenModal={setOpenCompensatoryModal}
        refresh={() => {
          /* refresh leave list */
        }}
      />
    </Box>
  );
};

export default TotalLeave;
